export default {
  name: 'Header',
  props: {
    msg: String
  }
}